import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { BLOG } from "@/constants/testIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/blog`)
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section id="journal" data-testid={BLOG.root} className="py-24 md:py-32 bg-bone-dark">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 mb-16 items-end gap-6">
          <div className="md:col-span-7">
            <p className="eyebrow mb-6">Journal</p>
            <h2 className="font-serif text-5xl md:text-7xl leading-[1.02]">
              Notes from the <span className="italic">shop floor.</span>
            </h2>
          </div>
          <p className="md:col-span-4 md:col-start-9 text-ink/70 md:text-right">
            Short essays on craft, tools, and the slow work of building things
            that last.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {posts.map((post, i) => (
            <motion.article
              key={post.id}
              data-testid={BLOG.card(post.id)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group"
            >
              <Link to={`/journal/${post.slug}`} className="block">
                <div className="overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-[60vh] object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                  />
                </div>
                <div className="mt-6">
                  <p className="eyebrow mb-3">
                    {post.date} · {post.read_time}
                  </p>
                  <h3 className="font-serif text-3xl leading-tight group-hover:text-clay transition-colors">
                    {post.title}
                  </h3>
                  <p className="mt-4 text-ink/70 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <span className="mt-6 inline-block eyebrow link-underline">
                    Read essay →
                  </span>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
